import React, { useEffect, useRef } from 'react';

interface HtmlRendererProps {
  html: string;
  className?: string;
  tagName?: any;
}

export const HtmlRenderer: React.FC<HtmlRendererProps> = ({
  html,
  className,
  tagName = 'div',
}) => {
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.innerHTML = html;
    }
  }, [html]);

  return React.createElement(tagName, { ref, className });
};
